import { render } from "./ProductFilter.vue?vue&type=template&id=848e211e"
import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/labelinsight-products/components/filter/ProductFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "848e211e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('848e211e', __exports__)) {
    api.reload('848e211e', __exports__)
  }
  
  module.hot.accept("./ProductFilter.vue?vue&type=template&id=848e211e", () => {
    api.rerender('848e211e', render)
  })

}


export default __exports__